import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Homepage from "./components/Homepage";
import About from "./components/About";
import Programs from "./components/Programs";
import Impact from "./components/Impact";
import Blog from "./components/Blog";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Donation from "./components/Donation";
import AdminPanel from "./components/AdminPanel";
import AdminLogin from "./components/AdminLogin";
import ToastTest from "./components/ToastTest";
import BlogDetail from "./components/BlogDetail";
import NewsDetail from "./components/NewsDetail";
import GovernmentSchemes from "./components/GovernmentSchemes";
import Apply from "./components/Apply";
import ContentContribution from "./components/ContentContribution";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/donate" element={<Donation />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminPanel />} />
          <Route path="/toast-test" element={<ToastTest />} />
          <Route path="/news" element={<Navigate to="/blog" replace />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/government-schemes" element={<GovernmentSchemes />} />
          <Route path="/contribute-content" element={<ContentContribution />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
